import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import teamAPI from "../../services/teamAPI";
import { useLocation } from "react-router-dom";
import useQueryURL from "../../../../utils/useQueryURL";

export const QUERY_KEY_TEAM = "signle-team"
export const QUERY_KEY_TEAM_MEMBERS_LIST = "team-members-list"
export const QUERY_KEY_SINGLE_TEAM_SPENDING_DEMAND_LIST = "team-single-spending-demands-list"

export interface OptionSingleTeam {
  pageSizeSpendingDemand?: number;
  currentSpendingDemandPage?: number;
  URLSpendingDemandPageId?: string  
}

function useSingleTeamCore(singleTeamId: string,
  handleNetworkErrorFunction:
    | ((error: AxiosError<unknown, any>, SreenContext: string | null) => void)
    | null,
  handleInternErrorFunction:
    | ((errorMessage: string | null, errorCode: number | null) => void)
    | null, 
    UserEmployeeId: string,
    option?: OptionSingleTeam 
) {


  const handleNetworkError = (
    error: AxiosError<unknown, any>,
    SreenContext: string | null
  ) => {
    if (handleNetworkErrorFunction) {
      handleNetworkErrorFunction(error, SreenContext);
    }
  };

  const [currentPageSpending, setCurrentPageSpending] = useState(1);
  const location: string = useLocation().search;
  const queryURLClient = useQueryURL();
  useEffect(() => {

    const cuurentPage = queryURLClient.getQueryValue(option?.URLSpendingDemandPageId||"")
    console.log("currentPageSpending", cuurentPage)
    setCurrentPageSpending(cuurentPage ? parseInt(cuurentPage) : 1)

  },[location, option?.URLSpendingDemandPageId, queryURLClient])



  const { data: singleTeam, isLoading, isError, error} = useQuery({
    queryFn: () => teamAPI.getFecthSingleTeamAPI(singleTeamId),
    queryKey: ["teams", singleTeamId]
    
  })

  const { data: membersList, isLoading : isLoadingMemberList, isFetching: isFetchingMemberList} = useQuery({
    queryFn: () => teamAPI.getFetchMembersListOfTeam(singleTeamId),
    queryKey: ["teams", singleTeamId, "members"]
  })



  const { data: spendingDemandList, isLoading : isLoadingspendingDemandList, isError : isErrorSP} = useQuery({
    queryFn: () => teamAPI.getFetchTeamAllSpendingDemand(singleTeamId, UserEmployeeId, {pageSize: option?.pageSizeSpendingDemand || 0, currentPage: currentPageSpending ||1}),
    queryKey: ["teams", singleTeamId, "spending-demands", option, currentPageSpending],
  })

  useEffect(() => {
    if(isError){
      handleNetworkError(error as AxiosError, "teamList")
    }
  },[isError]) //eslint-disable-line

  return {
    singleTeamData : singleTeam,
    isLoading : isLoading,
    memberList: {
      membersListData : membersList,
      isLoading : isLoadingMemberList,
      isFetching : isFetchingMemberList
    },
    spendingDemandList : {
      spendingDemandListData : spendingDemandList,
      isLoading : isLoadingspendingDemandList,
      isError : isErrorSP,
    },
  };
}

export default useSingleTeamCore;
